/* eslint-disable react/no-did-update-set-state */
import React, { Component } from "react"
import arrayMove from "array-move";
import { v4 as uuid } from "uuid"
import { I18n } from "react-redux-i18n";

import Modal from "@alboompro/boom-components/data-display/modal";
import Icon from "@alboompro/boom-components/general/icon";
import Button from "@alboompro/boom-components/general/button";

import { SortableContainer, SortableItem } from "./components/SortableHOC";
import DiscardChangesAlert from "./components/DiscardChangesAlert";
import QuestionDropDown from "./components/QuestionDropdown"
import TextEditor from "./components/TextEditor"

import {
  FooterContent,
  ModalWrapper,
  ItemsPanel,
  PanelHeader,
  PanelItem,
  EmptyFaqWrapper,
  AddNewFaqTooltip,
} from "./styles"

import "react-quill/dist/quill.snow.css";

class FAQManagerModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      faq: [],
      activeQuestionId: null,
      dropdownOpenedId: null,
      questionToBeRemovedId: null,
      discardChangesAlertVisible: false,
    }
  }

  componentDidMount() {
    const { currentValue } = this.props

    if(currentValue.length > 0) {
      this.setState(state => ({
        ...state,
        faq: currentValue,
        activeQuestionId: currentValue[0].id,
      }))
    }
  }
  
  componentDidUpdate() {
    const { faq, questionToBeRemovedId } = this.state

    // handler for questions removal (executed here to prevent dropdown error)
    if(questionToBeRemovedId !== null) {
      if(faq.length === 1) {
        this.setState(state => ({
          ...state,
          faq: [],
          activeQuestionId: null,
          questionToBeRemovedId: null,
        }))
      } else {
        let activeQuestionIndex = 0
        
        const updatedFaq = faq.filter((item, index) => {
          if(item.id === questionToBeRemovedId) {
            activeQuestionIndex = index
            return false
          }
          return true
        })
    
        if(activeQuestionIndex + 1 <= faq.length - 1) {
          activeQuestionIndex += 1
        } else {
          activeQuestionIndex -= 1
        }

        this.setState(state => ({
          ...state,
          faq: updatedFaq,
          activeQuestionId: faq[activeQuestionIndex].id,
          questionToBeRemovedId: null,
        }))
      }
    }
  }

  closeModal = (option) => {
    const { faq } = this.state
    const { handleClose, currentValue } = this.props

    if(option === "cancel") {
      handleClose()
    } else {
      const currentFaqInnerHTML = faq.map(item => ({ 
        id: item.id, 
        questionInnerHTML: item.questionInnerHTML,
        answerInnerHTML: item.answerInnerHTML
      }))
      
      const previousFaqInnerHTML = currentValue.map(item => ({ 
        id: item.id, 
        questionInnerHTML: item.questionInnerHTML,
        answerInnerHTML: item.answerInnerHTML
      }))

      const hasModifications = JSON.stringify(currentFaqInnerHTML) !== JSON.stringify(previousFaqInnerHTML)
      if(hasModifications) {
        this.setState(state => ({ ...state, discardChangesAlertVisible: true }))
      } else {
        handleClose()
      }
    }
  }

  handleCloseAlert = () => {
    this.setState(state => ({ ...state, discardChangesAlertVisible: false}))
  }

  confirmSelection = () => {
    const { updaterFn, name, handleClose } = this.props;
    const { faq } = this.state

    updaterFn({ prop: name, value: faq });
    handleClose()
  };

  handleAddNewFaq = () => {
    const { faq } = this.state
    
    const newFaqId = uuid()
    const newIndex = faq.length + 1

    const newFaqItem = {
      id: newFaqId,
      questionText: `${I18n.t("editPanel.FAQManager.faqPlaceholder.questionText") + newIndex}`,
      questionInnerHTML: `<p>${I18n.t("editPanel.FAQManager.faqPlaceholder.questionInnerHTML") + newIndex}</p>`,
      answerText: `${I18n.t("editPanel.FAQManager.faqPlaceholder.answerText") + newIndex}`,
      answerInnerHTML: `<p>${I18n.t("editPanel.FAQManager.faqPlaceholder.answerInnerHTML") + newIndex}</p>`,
    }

    const updatedFaq = [...faq, newFaqItem]

    this.setState(state => ({ 
      ...state, 
      faq: updatedFaq, 
      activeQuestionId: newFaqId 
    }))
  }

  handleClickItem = (itemId) => {
    const { activeQuestionId } = this.state

    if(itemId !== activeQuestionId) {
      this.setState(state => ({ ...state, activeQuestionId: itemId }))
    }
  }

  handleDropdownClick = (itemId) => {
    const { dropdownOpenedId } = this.state
    
    if(!dropdownOpenedId) {
      this.setState(state => ({ ...state, dropdownOpenedId: itemId }))
    } else {
      this.setState(state => ({ ...state, dropdownOpenedId: null }))
    }
  }

  duplicateQuestion = (faqIndex) => {
    const { faq } = this.state
    
    const questionCopy = faq[faqIndex]
    const newQuestionId = uuid()
    const updatedFaq = [...faq, {
      ...questionCopy,
      id: newQuestionId
    }]

    this.setState(state => ({ 
      ...state, 
      dropdownOpenedId: null,
      activeQuestionId: newQuestionId,
      faq: updatedFaq, 
    }))
  }

  removeQuestion = (faqId) => {
    this.setState(state => ({
      ...state,
      questionToBeRemovedId: faqId,
      dropdownOpenedId: null,
    }))
  }
  
  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState(state => ({
      ...state,
      faq: arrayMove(state.faq, oldIndex, newIndex) 
    }));
  };

  updateFaq = (faq) => {
    this.setState(state => ({ ...state, faq }))
  }

  render() {
    const { 
      activeQuestionId, 
      faq, 
      dropdownOpenedId, 
      discardChangesAlertVisible 
    } = this.state
    const { visible, locale } = this.props

    const activeFaq = faq.find(item => item.id === activeQuestionId)
    
    return (
      <Modal
        visible={visible}
        title={I18n.t("editPanel.FAQManager.title")}
        onClose={this.closeModal}
        rounded
        width={1190}
        bodyStyle={{ display: "flex", flex: 1, overflow: "hidden;" }}
        headerStyle={{ borderRadius: "5px 5px 0 0" }}
        style={{ borderRadius: "5px" }}
        footer={
          <FooterContent>
            <Button
              style={{
                backgroundColor: "transparent",
                border: "1px solid #bbbbbb"
              }}
              textStyle={{ color: "#525252" }}
              onClick={() => this.closeModal("cancel")}
            >
              {I18n.t("general.cancel")}
            </Button>
            <Button
              type="primary"
              style={{ backgroundColor: "#50AFF4" }}
              onClick={this.confirmSelection}
            >
              {I18n.t("general.save")}
            </Button>
          </FooterContent>
        }
      >
        <ModalWrapper>
          <ItemsPanel>
            <PanelHeader>
              <span className="items">
                {I18n.t("editPanel.FAQManager.itemsCounter")}{" "}
                <span>({faq.length})</span>
              </span>
              <button type="button" onClick={this.handleAddNewFaq}>
                <Icon 
                  kind="bold" 
                  group="interface-essential" 
                  category="remove-add" 
                  file="add-circle.svg" 
                  size="15" 
                  color="#44ADF8" 
                />
                {I18n.t("editPanel.FAQManager.addButton")}
              </button>
              {!activeFaq && (
                <AddNewFaqTooltip>
                  {I18n.t("editPanel.FAQManager.addNewFaqTooltipText")}
                </AddNewFaqTooltip>
              )}
            </PanelHeader>
            <div style={{ overflowY: "auto" }}>
              <SortableContainer onSortEnd={this.onSortEnd} distance={1} lockAxis="y">
                {faq.map((item, index) => (
                  <SortableItem index={index} key={`${index + 1}`}>
                    <PanelItem 
                      key={item.id} 
                      isActive={item.id === activeQuestionId} 
                      onClick={() => this.handleClickItem(item.id)} 
                    > 
                      <span className="index">{index+1}</span>
                      <p className="title">{item.questionText}</p>
                      <QuestionDropDown 
                        index={index}
                        itemId={item.id}
                        dropdownOpenedId={dropdownOpenedId}
                        handleDropdownClick={this.handleDropdownClick}
                        duplicateQuestion={this.duplicateQuestion}
                        removeQuestion={this.removeQuestion}
                      />
                    </PanelItem>
                  </SortableItem>
                ))}
              </SortableContainer>
            </div>
          </ItemsPanel>
          {activeFaq ? (
            <TextEditor
              locale={locale}
              faq={faq} 
              activeFaq={activeFaq}
              handleFaqUpdate={this.updateFaq}
            />
          ): (
            <EmptyFaqWrapper>
              <Icon 
                kind="light" 
                group="files-folders" 
                category="common-files" 
                file="common-file-empty.svg" 
                size="44" 
                color="#9F9F9F" 
              />
              <h4>{I18n.t("editPanel.FAQManager.emptyFaqTitle")}</h4>
              <p>{I18n.t("editPanel.FAQManager.emptyFaqMessage")}</p>
            </EmptyFaqWrapper>
          )}
        </ModalWrapper>
        {discardChangesAlertVisible && (
          <DiscardChangesAlert 
            handleCancel={this.handleCloseAlert} 
            handleDiscard={() => this.closeModal("cancel")}
          />
        )}
      </Modal>
    )
  }
}

export default FAQManagerModal;